import request from '@/utils/request'

export function login(data) {
    return request({
        url: '/sysUser/login',
        method: 'post',
        data
    })
}

export function getUserInfo() {
    return request({
        url: '/sysUser/info',
        method: 'get',
    })
}

export function logout() {
    return request({
        url: '/sysUser/logout',
        method: 'delete'
    })
}
